module.exports = __webpack_public_path__ + "static/media/avril-lavigne-lesb.f1c17c00.jpg";